import React, { useCallback, useEffect, useState } from "react";
import api from "../services/api";
import Header from "../components/Header";
import ListaPremium, { iniciaisDe } from "../components/ListaPremium";
import { useAuth } from "../context/AuthContext";
import { Button, Field, Input, Select, Textarea, Tag, Modal, tomDoStatus, dataBR, mascaraCNJ, cnjValido } from "../components/ui";

const FORM_VAZIO = {
    cod_contrato: "", num_processo: "", status_processo: "",
    vara: "", comarca: "", parte_contraria: "", descricao: ""
};
const STATUS_PROCESSO = ["em andamento", "cancelado", "concluido"];

const Processos = () => {
    const { podeEditar } = useAuth();
    const [busca, setBusca] = useState(() => new URLSearchParams(window.location.search).get("q") || "");
    const [processos, setProcessos] = useState([]);
    const [contratos, setContratos] = useState([]);
    const [prazos, setPrazos] = useState([]);
    const [contratoSelecionado, setContratoSelecionado] = useState(null);
    const [processoSelecionado, setProcessoSelecionado] = useState(null);
    const [mostrarContratos, setMostrarContratos] = useState(false);
    const [mostrarAdd, setMostrarAdd] = useState(false);
    const [mostrarInfo, setMostrarInfo] = useState(false);
    const [mostrarEdit, setMostrarEdit] = useState(false);
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState(null);
    const [formData, setFormData] = useState(FORM_VAZIO);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const carregarProcessos = useCallback(async () => {
        try {
            const response = await api.get("/processos");
            setProcessos(response.data);
        } catch (error) {
            console.error("Erro ao buscar processos:", error);
        }
    }, []);

    useEffect(() => {
        carregarProcessos();
        api.get("/contratos").then((r) => setContratos(r.data)).catch(() => {});
    }, [carregarProcessos]);

    useEffect(() => {
        if (!processoSelecionado?.num_processo) return;
        api.get(`/processos/${processoSelecionado.num_processo}/prazos`)
            .then((r) => setPrazos(r.data))
            .catch(() => {});
    }, [processoSelecionado]);

    const criarProcesso = async (e) => {
        e.preventDefault();
        setErro(null);
        if (!cnjValido(formData.num_processo)) {
            setErro("Número de processo inválido. Confira os dígitos.");
            return;
        }
        setCarregando(true);
        try {
            await api.post("/processos", { ...formData, cod_contrato: contratoSelecionado.cod_contrato });
            setMostrarAdd(false);
            carregarProcessos();
            setFormData(FORM_VAZIO);
        } catch (err) {
            setErro(err.response?.data?.error || err.message);
        } finally {
            setCarregando(false);
        }
    };

    const editProcesso = async (e) => {
        e.preventDefault();
        setCarregando(true);
        setErro(null);
        try {
            await api.put(`/processos/${processoSelecionado.num_processo}`, formData);
            carregarProcessos();
            setMostrarEdit(false);
        } catch (err) {
            setErro(err.response?.data?.error || "Não foi possível salvar o processo.");
        } finally {
            setCarregando(false);
        }
    };

    const deletarProcesso = async () => {
        if (!window.confirm("Excluir este processo?")) return;
        try {
            await api.delete(`/processos/${processoSelecionado.num_processo}`);
            carregarProcessos();
            setMostrarInfo(false);
        } catch (error) {
            alert(error.response?.data?.error || "Não foi possível excluir o processo.");
        }
    };

    const processosFiltrados = processos.filter((p) =>
        String(p.cod_contrato || "").includes(busca.toLowerCase()) ||
        (p.nome_cliente || "").toLowerCase().includes(busca.toLowerCase()) ||
        (p.status_processo || "").toLowerCase().includes(busca.toLowerCase()) ||
        String(p.num_processo || "").includes(busca.toLowerCase()) ||
        (p.parte_contraria || "").toLowerCase().includes(busca.toLowerCase())
    );

    return (
        <div>
            <Header />

            <main className="page">
                <div className="toolbar">
                    <h2 style={{ margin: 0 }}>Processos</h2>
                    <div className="toolbar-spacer">
                        <Input placeholder="Buscar" value={busca} onChange={(e) => setBusca(e.target.value)} />
                        {podeEditar && <Button onClick={() => setMostrarContratos(true)}>Novo processo</Button>}
                    </div>
                </div>

                <ListaPremium
                    vazio="Nenhum processo encontrado."
                    itens={processosFiltrados.map((p) => ({
                        chave: p.num_processo,
                        iniciais: iniciaisDe(p.nome_cliente),
                        inicialTom: p.status_processo === "concluido" ? "success" : p.status_processo === "cancelado" ? "danger" : "accent",
                        titulo: p.num_processo,
                        subtitulo: [
                            p.nome_cliente,
                            p.tipo_servico,
                            p.parte_contraria ? `réu: ${p.parte_contraria}` : null,
                            p.prazos_pendentes > 0 ? `${p.prazos_pendentes} prazo(s) pendente(s)` : null
                        ].filter(Boolean).join(" · "),
                        status: p.status_processo,
                        aoClicar: () => { setMostrarInfo(true); setProcessoSelecionado(p); }
                    }))}
                />

                {mostrarContratos && (
                    <Modal titulo="Escolha o contrato" largo onFechar={() => setMostrarContratos(false)}>
                        <div className="scroll-x">
                            <table className="table">
                                <thead><tr><th>Cód.</th><th>Cliente</th><th>Status</th><th>Tipo</th></tr></thead>
                                <tbody>
                                    {contratos.map((ct) => (
                                        <tr key={ct.cod_contrato} className="clicavel" onClick={() => { setMostrarContratos(false); setContratoSelecionado(ct); setFormData(FORM_VAZIO); setErro(null); setMostrarAdd(true); }}>
                                            <td className="num">{ct.cod_contrato}</td>
                                            <td>{ct.nome_cliente}</td>
                                            <td><Tag tom={tomDoStatus(ct.status_contrato)}>{ct.status_contrato}</Tag></td>
                                            <td>{ct.tipo_servico}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-acoes">
                            <Button variante="secondary" onClick={() => setMostrarContratos(false)}>Voltar</Button>
                        </div>
                    </Modal>
                )}

                {mostrarAdd && contratoSelecionado && (
                    <Modal titulo="Novo processo" onFechar={() => setMostrarAdd(false)}>
                        <form onSubmit={criarProcesso} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                            <div className="grid-form">
                                <Field label="Contrato"><Input value={`Contrato ${contratoSelecionado.cod_contrato}`} readOnly /></Field>
                                <Field label="Nº do processo (CNJ)">
                                    <Input name="num_processo" required
                                        placeholder="0000000-00.0000.0.00.0000"
                                        value={formData.num_processo}
                                        onChange={(e) => setFormData((p) => ({ ...p, num_processo: mascaraCNJ(e.target.value) }))} />
                                    {formData.num_processo.replace(/\D/g, "").length === 20 && !cnjValido(formData.num_processo) && (
                                        <span className="erro" style={{ fontSize: 13.5 }}>Dígito verificador não confere</span>
                                    )}
                                </Field>
                                <Field label="Status">
                                    <Select name="status_processo" required value={formData.status_processo} onChange={handleChange}>
                                        <option value="">Selecione</option>
                                        {STATUS_PROCESSO.map((s) => <option key={s} value={s}>{s}</option>)}
                                    </Select>
                                </Field>
                                <Field label="Vara"><Input name="vara" placeholder="2ª Vara Cível" value={formData.vara} onChange={handleChange} /></Field>
                                <Field label="Comarca"><Input name="comarca" placeholder="João Pessoa/PB" value={formData.comarca} onChange={handleChange} /></Field>
                                <Field label="Parte contrária (réu)" className="span-2">
                                    <Input name="parte_contraria" value={formData.parte_contraria} onChange={handleChange} />
                                </Field>
                                <Field label="Descrição" className="span-2"><Textarea name="descricao" value={formData.descricao} onChange={handleChange} /></Field>
                            </div>
                            <div className="modal-acoes">
                                {erro && <p className="erro">{erro}</p>}
                                <Button variante="secondary" onClick={() => { setMostrarAdd(false); setMostrarContratos(true); }}>Voltar</Button>
                                <Button type="submit" disabled={carregando}>{carregando ? "Salvando..." : "Salvar"}</Button>
                            </div>
                        </form>
                    </Modal>
                )}

                {mostrarInfo && processoSelecionado && (
                    <Modal titulo={`Processo ${processoSelecionado.num_processo}`} onFechar={() => setMostrarInfo(false)}>
                        <div className="grid-form">
                            <Field label="Contrato"><Input value={processoSelecionado.cod_contrato} readOnly /></Field>
                            <Field label="Status"><Input value={processoSelecionado.status_processo} readOnly /></Field>
                            <Field label="Vara"><Input value={processoSelecionado.vara || "—"} readOnly /></Field>
                            <Field label="Comarca"><Input value={processoSelecionado.comarca || "—"} readOnly /></Field>
                            <Field label="Parte contrária (réu)" className="span-2"><Input value={processoSelecionado.parte_contraria || "—"} readOnly /></Field>
                            <Field label="Descrição" className="span-2"><Textarea value={processoSelecionado.descricao || ""} readOnly /></Field>
                        </div>
                        <div>
                            <span className="card-kicker">Prazos do processo</span>
                            <ul className="mini-lista">
                                {prazos.map((pr) => (
                                    <li key={pr.cod_prazo}>{pr.nome_prazo} · {dataBR(pr.data_prazo)} <Tag tom={tomDoStatus(pr.status_prazo)}>{pr.status_prazo}</Tag></li>
                                ))}
                                {prazos.length === 0 && <li className="text-muted">Nenhum prazo cadastrado.</li>}
                            </ul>
                        </div>
                        <div className="modal-acoes">
                            {podeEditar && <Button variante="danger" onClick={deletarProcesso}>Excluir</Button>}
                            <Button variante="secondary" onClick={() => setMostrarInfo(false)}>Voltar</Button>
                            {podeEditar && (
                                <Button onClick={() => {
                                    setMostrarInfo(false); setErro(null); setMostrarEdit(true);
                                    setFormData({
                                        cod_contrato: processoSelecionado.cod_contrato,
                                        num_processo: processoSelecionado.num_processo,
                                        status_processo: processoSelecionado.status_processo,
                                        vara: processoSelecionado.vara || "",
                                        comarca: processoSelecionado.comarca || "",
                                        parte_contraria: processoSelecionado.parte_contraria || "",
                                        descricao: processoSelecionado.descricao || ""
                                    });
                                }}>Editar</Button>
                            )}
                        </div>
                    </Modal>
                )}

                {mostrarEdit && processoSelecionado && (
                    <Modal titulo="Editar processo" onFechar={() => setMostrarEdit(false)}>
                        <form onSubmit={editProcesso} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                            <div className="grid-form">
                                <Field label="Contrato"><Input value={formData.cod_contrato} readOnly /></Field>
                                <Field label="Nº do processo"><Input value={formData.num_processo} readOnly /></Field>
                                <Field label="Status">
                                    <Select name="status_processo" value={formData.status_processo} onChange={handleChange}>
                                        {STATUS_PROCESSO.map((s) => <option key={s} value={s}>{s}</option>)}
                                    </Select>
                                </Field>
                                <Field label="Vara"><Input name="vara" value={formData.vara} onChange={handleChange} /></Field>
                                <Field label="Comarca"><Input name="comarca" value={formData.comarca} onChange={handleChange} /></Field>
                                <Field label="Parte contrária (réu)"><Input name="parte_contraria" value={formData.parte_contraria} onChange={handleChange} /></Field>
                                <Field label="Descrição" className="span-2"><Textarea name="descricao" value={formData.descricao} onChange={handleChange} /></Field>
                            </div>
                            <div className="modal-acoes">
                                {erro && <p className="erro">{erro}</p>}
                                <Button variante="secondary" onClick={() => setMostrarEdit(false)}>Voltar</Button>
                                <Button type="submit" disabled={carregando}>{carregando ? "Salvando..." : "Salvar"}</Button>
                            </div>
                        </form>
                    </Modal>
                )}
            </main>
        </div>
    );
};

export default Processos;
